import styled from 'styled-components';

import { COLORS } from '../../theme/tokens';

export const Root = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  color: ${COLORS.icon};
`;
